"use strict";

// Array.from polyfill
if (!Array.from) {
	Array.from = (function () {
		var toStr = Object.prototype.toString;
		var isCallable = function (fn) {
			return typeof fn === "function" || toStr.call(fn) === "[object Function]";
		};
		var toInteger = function (value) {
			var number = Number(value);
			if (isNaN(number)) {
				return 0;
			}
			if (number === 0 || !isFinite(number)) {
				return number;
			}
			return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
		};
		var maxSafeInteger = Math.pow(2, 53) - 1;
		var toLength = function (value) {
			var len = toInteger(value);
			return Math.min(Math.max(len, 0), maxSafeInteger);
		};

		// The length property of the from method is 1.
		return function from(arrayLike /*, mapFn, thisArg */) {
			// 1. Let C be the this value.
			var C = this;

			// 2. Let items be ToObject(arrayLike).
			var items = Object(arrayLike);

			// 3. ReturnIfAbrupt(items).
			if (arrayLike == null) {
				throw new TypeError("Array.from requires an array-like object - not null or undefined");
			}

			// 4. If mapfn is undefined, then let mapping be false.
			var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
			var T;
			if (typeof mapFn !== "undefined") {
				// 5. else
				// 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
				if (!isCallable(mapFn)) {
					throw new TypeError("Array.from: when provided, the second argument must be a function");
				}

				// 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
				if (arguments.length > 2) {
					T = arguments[2];
				}
			}

			// 10. Let lenValue be Get(items, "length").
			// 11. Let len be ToLength(lenValue).
			var len = toLength(items.length);

			// 13. If IsConstructor(C) is true, then
			// 13. a. Let A be the result of calling the [[Construct]] internal method
			// of C with an argument list containing the single item len.
			// 14. a. Else, Let A be ArrayCreate(len).
			var A = isCallable(C) ? Object(new C(len)) : new Array(len);

			// 16. Let k be 0.
			var k = 0;
			// 17. Repeat, while k < len… (also steps a - h)
			var kValue;
			while (k < len) {
				kValue = items[k];
				if (mapFn) {
					A[k] = typeof T === "undefined" ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
				} else {
					A[k] = kValue;
				}
				k += 1;
			}
			// 18. Let putStatus be Put(A, "length", len, true).
			A.length = len;
			// 20. Return A.
			return A;
		};
	})();
}

// forEach polyfill
if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (var i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

// closest polyfill
if (!Element.prototype.matches) {
	Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}
if (!Element.prototype.closest) {
	Element.prototype.closest = function (s) {
		var el = this;

		do {
			if (Element.prototype.matches.call(el, s)) return el;
			el = el.parentElement || el.parentNode;
		} while (el !== null && el.nodeType === 1);
		return null;
	};

}

var mnsd = mnsd || {};
mnsd.util = $.extend(
	{
		debounce: function (func, wait, immediate) {
			var timeout;
			return function () {
				var context = this,
					args = arguments;
				var later = function () {
					timeout = null;
					if (!immediate) {
						func.apply(context, args);
					}
				};
				var callNow = immediate && !timeout;
				clearTimeout(timeout);
				timeout = setTimeout(later, wait || 200);
				if (callNow) {
					func.apply(context, args);
				}
			};
		},
	},{
		hasElement(el) {
			return $(el).length > 0;
		},
	},
	mnsd.util || {}
);
mnsd.Event = mnsd.Event || {};
mnsd.Event.emitter = {
  subscribers: {},
  on: function (s, t, i) {
    (this.subscribers[s] = this.subscribers[s] || []),
      this.subscribers[s].push({ callback: t, context: i });
  },
  off: function (s, t, i) {
    var r,
      c,
      e = this.subscribers[s];
    if (e)
      for (r = e.length - 1; r >= 0; ) {
        if (((c = e[r]), c.callback === t && (!i || c.context === i))) {
          e.splice(r, 1);
          break;
        }
        r--;
      }
  },
  emit: function (s) {
    var t,
      i = this.subscribers[s],
      r = 0,
      c = Array.prototype.slice.call(arguments, 1);
    if (i)
      for (; r < i.length; )
        (t = i[r]), t.callback.apply(t.context || this, c), r++;
  },
};
mnsd.View = mnsd.View || {};
mnsd.View.category = function (htOptions) {
  $.extend(this, htOptions || {});
  this.init();
};
mnsd.View.category.prototype = $.extend(
  {
    _bMouseOver: false,
    init: function () {
      this._assignElements();
      this._attachEventHandlers();
    },
    _assignElements: function () {
      this._welGnb = $("#_mnsd_gnb");
      this._welNavWrap = this._welGnb.find(".mnsd_nav_bar");
      this._welNavList = this._welNavWrap.find(".mnsd_nav_menu");
      this._welNavTopMenu = this._welNavList.find(".mnsd_nav_mn");
      this._welNavBubbleTip = this._welGnb.find(".mnsd_bubble_tip");
    },
    _attachEventHandlers: function () {
      this._welNavBubbleTip.on(
        "click",
        ".mnsd_bubble_close",
        $.proxy(this._onClickBubbleTipClose, this)
      );
      this._welNavList.on(
        "focusin.a11y",
        ".mnsd_nav_mn",
        $.proxy(this._onFocusinA11y, this)
      );
      this._welNavList.on(
        "click.a11y",
        ".mnsd_nav_a11y",
        $.proxy(this._onClickA11y, this)
      );
      this._welNavList.on("keydown.a11y", $.proxy(this._onKeydownA11y, this));
      this._welNavList
        .menuAim({
          rowSelector: ".mnsd_nav_mn",
          activate: $.proxy(this._activeSubMenu, this),
          deactivate: $.proxy(this._deactivateSubMenu, this),
          enter: $.proxy(this._enterSubMenu, this),
          exitMenu: function () {
            return true;
          },
          submenuDirection: "below",
        })
        .find(".mnsd_nav_mn")
        .off("click");

      this._welNavList.on(
        "mouseenter",
        ".mnsd_nav_sublst > .mnsd_nav_submn",
        $.proxy(this._onMouseenterSubmenu, this)
      );
    },
    _onMouseenterSubmenu: function (e) {
      var welTarget = $(e.currentTarget);
      this._showNavSubMenu(welTarget);
    },
    _onClickBubbleTipClose: function () {
      this._welNavBubbleTip.removeClass("on");
    },
    _activeSubMenu: function (elem) {
      var welTarget = $(elem);
      this._showNavSubMenu(welTarget);
    },
    _deactivateSubMenu: function (elem) {
      var welTarget = $(elem);
      this._hideNavSubMenu(welTarget);
    },
    _enterSubMenu: function () {
      this._bMouseOver = true;
      this._welNavList.find(".mnsd_nav_a11y").hide();
    },
    _onFocusinA11y: function (e) {
      var welTarget = $(e.currentTarget);
      if (this._bMouseOver) {
        return;
      }
      welTarget.find(".mnsd_nav_a11y").show();
      welTarget.siblings(":not(.on)").find(".mnsd_nav_a11y").hide();
    },
    _onClickA11y: function (e) {
      var welTarget = $(e.currentTarget);
      var welCurrentMenu = welTarget.parent();
      if (welCurrentMenu.hasClass("on")) {
        this._hideNavSubMenu(welCurrentMenu);
      } else {
        this._showNavSubMenu(welCurrentMenu);
      }
    },
    _onKeydownA11y: function (e) {
      var sKeyCode = e.sKeyCode || e.which;
      var bTabKey = sKeyCode === 9;
      var bEscKey = sKeyCode === 27;
      var aActiveMenu = null;
      var nActive = 0;
      var welCurrentMenu = null;

      if (bEscKey) {
        aActiveMenu = this._welNavWrap.find("li.on");
        nActive = aActiveMenu.length;
        if (nActive) {
          welCurrentMenu = $(aActiveMenu.get(nActive - 1));
          this._hideNavSubMenu(welCurrentMenu);
          welCurrentMenu.find("li:not(.on) .mnsd_nav_a11y").hide();
          welCurrentMenu.find(">a").focus();
        }
      }
      if (bTabKey) {
        this._bMouseOver = false;
      }
    },
    _showNavSubMenu: function (welCurrent) {
      welCurrent.addClass("on").siblings().removeClass("on");
      welCurrent
        .find(".mnsd_nav_a11y")
        .attr("aria-expanded", "true")
        .end()
        .siblings()
        .find(".mnsd_nav_a11y")
        .attr("aria-expanded", "false")
        .hide();
      welCurrent
        .find(".mnsdctg_subtab_area")
        .attr("aria-hidden", "false")
        .end()
        .siblings()
        .find(".mnsdctg_subtab_area")
        .attr("aria-hidden", "true");
    },
    _hideNavSubMenu: function (welCurrent) {
      welCurrent.removeClass("on");
      welCurrent.find(".mnsd_nav_a11y").attr("aria-expanded", "false");
      welCurrent.find(".mnsdctg_subtab_area").attr("aria-hidden", "true");
    },
  },
  mnsd.Event.emitter
);
// 카테고리js추가
mnsd.View.navigation = function (htOptions) {
  $.extend(this, htOptions || {});
  this.init();
};
mnsd.View.navigation.prototype = {
  htCtgData: null,
  _bMouseOver: false,
  init: function () {
    this._assignElements();
    this._attachEventHandlers();
  },
  _assignElements: function () {
    this._welCtgAll = $(".mnsdctg_ctg");
    this._welCtgAllOpen = this._welCtgAll.find(".mnsdctg_ctg_open");
    this._welCtgTotalLayer = this._welCtgAll.find(".mnsdctg_total");
    this._welCtgTotalDimmed = this._welCtgTotalLayer.find(".mnsdctg_dimmed");
    this._welCtgContent = this._welCtgTotalLayer.find(".mnsdctg_cont");
    this._welCtgList = this._welCtgContent.find(".mnsdctg_list");
    this._welCtgTopMenu = this._welCtgList.find(".mnsdctg_top_mn");

    this._welAsideBar = $("#_cmskyCard, #sky_scraper");
  },
  _attachEventHandlers: function () {
    this._welCtgAllOpen.on(
      "click",
      $.proxy(this._onClickCategoryAllOpen, this)
    );

    this._welCtgAll.on(
      "mouseenter",
      $.proxy(this._onMouseenterCategoryOpen, this)
    );
    this._welCtgAll.on(
      "mouseleave",
      $.proxy(this._onMouseleaveCategoryOpen, this)
    );

    this._welCtgTotalDimmed.on(
      "mouseenter",
      $.proxy(this._onMouseenterCategoryDimmed, this)
    );

    this._welCtgTopMenu.on(
      "click",
      ".mnsdctg_top_lnk",
      $.proxy(this._onClickCategoryTopLink, this)
    );
    this._welCtgAll
      .next()
      .find("a, button")
      .eq(0)
      .on("focusin", $.proxy(this._onCategoryNextFocus, this));

    this._welCtgList.menuAim({
      rowSelector: ".mnsdctg_top_lnk",
      enter: $.proxy(this._enterSubMenu, this),
      exitMenu: $.proxy(this._exitSubMenu, this),
    });
  },
  _onMouseenterCategoryOpen: function () {
    this._showTotalCtgLayer();
    this._showSubMenu(this._welCtgList.find(".mnsdctg_top_mn").eq(0));
    this._bOpenSubArea = true;
  },
  _onMouseleaveCategoryOpen: function () {
    this._bOpenSubArea = false;
    this._checkSubCategoryArea();
  },
  _onMouseenterCategoryDimmed: function () {
    this._bOpenSubArea = false;
    this._hideTotalCtgLayer();
  },
  _checkSubCategoryArea: function () {
    this._oTimeoutCate = setTimeout(() => {
      if (this._bOpenSubArea) {
        clearTimeout(this._oTimeoutCate);
        this._oTimeoutCate = null;
        return;
      } else {
        this._hideTotalCtgLayer();
      }
    }, 200);
  },
  _onCategoryNextFocus: function () {
    if (this._welCtgAllOpen.hasClass("on")) {
      this._hideTotalCtgLayer();
    }
  },
  _onClickCategoryTopLink: function (e) {
    e.preventDefault();

    var welTarget = $(e.currentTarget);
    var welTargetList = welTarget.parent();

    if (this._bMouseOver) {
      return;
    }

    if (welTargetList.hasClass("on")) {
      this._hideSubMenu(welTargetList);
      welTarget.attr("aria-expanded", "false");
    } else {
      this._showSubMenu(welTargetList);
      welTarget.attr("aria-expanded", "true");
      welTargetList
        .siblings()
        .find(".mnsdctg_top_lnk")
        .attr("aria-expanded", "false");
    }
  },
  _enterSubMenu: function (elem) {
    var welTarget = $(elem).parent();
    this._bMouseOver = true;
    this._showSubMenu(welTarget);
  },
  _exitSubMenu: function () {
    return true;
  },
  _showSubMenu: function (welCurrentMenu) {
    welCurrentMenu.addClass("on").siblings().removeClass("on");
    welCurrentMenu
      .find(".mnsdctg_sub_area")
      .attr("aria-hidden", "false")
      .end()
      .siblings()
      .find(".mnsdctg_sub_area")
      .attr("aria-hidden", "true");

    this._setSubMenuHeight(
      welCurrentMenu.find(">.mnsdctg_sub_area").outerHeight()
    );
  },
  _hideSubMenu: function (welCurrentMenu) {
    welCurrentMenu.removeClass("on");
    welCurrentMenu.find(">.mnsdctg_sub_area").attr("aria-hidden", "true");
  },
  _onClickCategoryAllOpen: function (e) {
    e.preventDefault();

    if (this._welCtgAllOpen.hasClass("on")) {
      this._hideTotalCtgLayer();
    } else {
      this._showTotalCtgLayer();
      this._showSubMenu(this._welCtgList.find(".mnsdctg_top_mn").eq(0));
    }
  },
  _showTotalCtgLayer: function () {
    this._welCtgAllOpen.addClass("on").attr("aria-expanded", "true");
    this._welCtgTotalLayer
      .addClass("on")
      .attr("aria-hidden", "false")
      .on("keydown.ctgall", $.proxy(this._onKeydownCtgLayer, this));
    this._welAsideBar.addClass("off");
  },
  _hideTotalCtgLayer: function () {
    this._hideSubMenu(this._getCurrentMenu());
    this._welCtgAllOpen.removeClass("on").attr("aria-expanded", "false");
    this._welCtgTotalLayer
      .removeClass("on")
      .attr("aria-hidden", "true")
      .off("keydown.ctgall");
    this._welAsideBar.removeClass("off");
  },
  _onKeydownCtgLayer: function (e) {
    var sKeyCode = e.sKeyCode || e.which;
    var bTabKey = sKeyCode === 9;
    var bEscKey = sKeyCode === 27;
    var welCurrentMenu = null;

    if (bEscKey) {
      welCurrentMenu = this._getCurrentMenu();

      if (welCurrentMenu.length) {
        this._hideSubMenu(welCurrentMenu);
        welCurrentMenu.find(">.mnsdctg_top_lnk").focus();
      } else {
        this._hideTotalCtgLayer();
        this._welCtgAllOpen.focus();
      }
    }

    if (bTabKey) {
      this._bMouseOver = false;
    }
  },
  _setSubMenuHeight: function (nHeight) {
    this._welCtgContent.css("min-height", nHeight);
  },
  _getCurrentMenu: function () {
    return this._welCtgList.find(".mnsdctg_top_mn").filter(".on");
  },
  _gridLayout: function (welSubColGroup, nSubMenuCol) {
    var welSubList = welSubColGroup.find(".mnsdctg_sub_lst");
    var nSubCount = welSubList.length;
    var nListWidth = welSubColGroup.width() / welSubList.eq(0).width();
    var nCol = Math.min(nSubMenuCol, Math.round(nListWidth)) || 1;
    var aColumns = null;
    var buildColumn = function (nCol) {
      var cols = [];
      while (nCol--) {
        var wrap = $('<div class="mnsdctg_sub_col" />').css({
          float: "left",
          height: "auto",
        });
        welSubColGroup.append(wrap);
        cols.push(wrap);
      }
      return cols;
    };
    var getColumsShortest = function () {
      var shortest = aColumns[0];
      for (var i = aColumns.length; i--; ) {
        if (aColumns[i].height() <= shortest.height()) {
          shortest = aColumns[i];
        }
      }
      return shortest;
    };

    welSubColGroup.empty();

    if (nSubCount < nCol) {
      nCol = nSubCount;
    }

    aColumns = buildColumn(nCol);

    welSubList.each(function () {
      var welTarget = $(this);
      getColumsShortest().append(welTarget);
    });

    welSubColGroup
      .addClass("mnsdctg_sub_colgroup")
      .find(".mnsdctg_sub_col")
      .removeAttr("style");
  },
};
mnsd.View.tabMenu = function (htOptions) {
  $.extend(this, htOptions || {});
  this.init();
};
mnsd.View.tabMenu.prototype = $.extend(
  {
    init: function () {
      this._assignElements();
      this._attachEventHandlers();
    },
    _assignElements: function () {
      this._welBody = $("body");
    },
    _attachEventHandlers: function () {
      this._welBody.on(
        "click",
        ".js_cmmnsd_tab",
        $.proxy(this._onClickTabmenu, this)
      );
    },
    _onClickTabmenu: function (e) {
      e.preventDefault();

      var welTarget = $(e.currentTarget);
      var welTabWrap = welTarget.closest(".js_cmmnsd_tabwrap");
      var welTabList = welTarget.parent();
      var welTabPanel = welTabWrap.find(".js_cmmnsd_tabpanel");
      var welActivePanel = welTabPanel.eq(welTabList.index());

      var isLoadingData = welActivePanel.hasClass("js_loading_data");
      var sEventNamespace = "clickTabmenu." + welTabWrap.data("tabname");

      if (welTabList.hasClass("on")) {
        return;
      }

      welTabList.addClass("on").siblings().removeClass("on");
      welTabList
        .siblings()
        .find(".js_cmmnsd_tab")
        .attr("aria-selected", "false");
      welTarget.attr("aria-selected", "true");
      welActivePanel.addClass("on").siblings().removeClass("on");

      if (isLoadingData) {
        this.emit(sEventNamespace, welTarget, welActivePanel);
      }
    },
  },
  mnsd.Event.emitter
);
mnsd.View.observer = function (htOptions) {
	$.extend(this, htOptions || {});
	this.init();
};
mnsd.View.observer.prototype = {
	io: null,
	init: function () {
		this._assignComponent();
	},
	_assignComponent: function () {
		// IntersectionObserver 를 등록한다.
		this.io = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					// 관찰 대상이 viewport 안에 들어온 경우 'tada' 클래스를 추가
					if (entry.intersectionRatio > 0) {
						entry.target.classList.add("show");
					}
				});
			},
			{ threshold: 0.3 }
		);

		// 관찰할 대상을 선언하고, 해당 속성을 관찰시킨다.
		const boxElList = document.querySelectorAll(this.ioName);

		Array.from(boxElList).forEach((el) => {
			this.io.observe(el);
		});
	},
};
mnsd.View.mediaObserver = function (htOptions) {
	$.extend(this, htOptions || {});
	this.init();
};
mnsd.View.mediaObserver.prototype = {
	io: null,
	init: function () {
		this._assignComponent();
	},
	_assignComponent: function () {
		// IntersectionObserver 를 등록한다.
		this.io = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					// 관찰 대상이 viewport 안에 들어온 경우 'tada' 클래스를 추가
					if (entry.isIntersecting) {
						entry.target.classList.add("playing");
						entry.target.querySelector(`video`).play();
					} else {
						entry.target.classList.remove("playing");
						entry.target.querySelector(`video`).pause();
					}
				});
			},
			{ threshold: 0.3 }
		);

		// 관찰할 대상을 선언하고, 해당 속성을 관찰시킨다.
		const boxElList = document.querySelectorAll(this.ioName);
		Array.from(boxElList).forEach((el) => {
			this.io.observe(el);
		});
	},
};
mnsd.View.mediaPlayer = function () {
	this.init();
};
mnsd.View.mediaPlayer.prototype = {
	init: function () {
		this._assignElements();
		this._attachEventHandlers();
		this._initVar();
	},
	_initVar: function () {
		this._prevPlayIndex = 0;
	},
	_assignElements: function () {
		this._welMediaWrap = document.querySelector(`.mnsd_tryon_wrap`);
		this._welMediaItem = this._welMediaWrap.querySelectorAll(`.mnsd_grid_item`);
	},
	_attachEventHandlers: function () {
		this._isScroll();
		this._mouseoverPlayer();
	},
	_isScroll: function () {
		let timer = null;
		document.addEventListener("scroll", () => {
			if (!timer) {
				timer = setTimeout(() => {
					this._isInViewport();
					timer = null;
				}, 50);
			}
		});
	},
	_isInViewport: function () {
		if (this._welMediaItem[this._prevPlayIndex].getBoundingClientRect().top > -this._welMediaItem[this._prevPlayIndex].offsetHeight * 0.4 && this._welMediaItem[this._prevPlayIndex].getBoundingClientRect().top + this._welMediaItem[this._prevPlayIndex].offsetHeight * 0.5 < window.innerHeight) {
			if (!this._welMediaItem[this._prevPlayIndex].classList.contains(`playing`)) {
				this._welMediaItem[this._prevPlayIndex].classList.add(`playing`);
				this._welMediaItem[this._prevPlayIndex].querySelector(`video`).play();
			}
		} else {
			if (this._welMediaItem[this._prevPlayIndex].classList.contains(`playing`)) {
				this._welMediaItem[this._prevPlayIndex].classList.remove(`playing`);
				this._welMediaItem[this._prevPlayIndex].querySelector(`video`).pause();
			}
		}
	},
	_mouseoverPlayer: function () {
		let welVideoPlaying = document.querySelector(`.mnsd_grid_item.on.playing`);
		Array.from(this._welMediaItem).forEach((welVideoPlaying) => {
			welVideoPlaying.addEventListener(`mouseover`, (event) => {
				this._removeActiveClasses();
				welVideoPlaying.querySelector(`.mnsd_tryon_video video`).play();
				welVideoPlaying.classList.add(`on`, `playing`);
				this._prevPlayIndex = Array.from(this._welMediaItem).indexOf(event.target.closest(`.mnsd_grid_item`));
			});
		});
	},
	_removeActiveClasses: function () {
		Array.from(this._welMediaItem).forEach((welVideoPlaying) => {
			welVideoPlaying.querySelector(`.mnsd_tryon_video video`).pause();
			welVideoPlaying.classList.remove(`on`, `playing`);
		});
	},
};
mnsd.View.brandLookBook = function (htOptions) {
	$.extend(this, htOptions || {});
	this.init();
};
mnsd.View.brandLookBook.prototype = $.extend(
	{
		count: 1,
		flag: true,
		init: function () {
			this._assignElements();
      this._getItemLength();
			this._setInitialSlide();
			this._initialSliceCount();
			this._handleController();
			this._attachEvent();
			this._setLazyLoadImage();
		},
		_assignElements: function () {
			this._welSlideCount = document.querySelector(".mnsd_lookbook_scount");
			this._welPrevButton = document.querySelector(".mnsd_lookbook_prev");
			this._welNextButton = document.querySelector(".mnsd_lookbook_next");
			this._welLooBookSlide = document.querySelector(".mnsd_lookbook_slide");
			this._welVisualBox = document.querySelector(".mnsd_lookbook_visualbox");
			this._welLookTitleBox = document.querySelector(".mnsd_lookbook_title");
			this._welLookProductBox = document.querySelector(".mnsd_lookbook_plist");     
		},
    _getItemLength: function() {
      this.total = this._welVisualBox.querySelectorAll(".mnsd_lookbook_visual").length 
    },
		_setLazyLoadImage: function () {
			if (this.count < this.total) {
				const currentVisualImage = document.querySelectorAll(".mnsd_lookbook_visual img")[this.count - 1];
				const nextVisualImage = document.querySelectorAll(".mnsd_lookbook_visual img")[this.count];
				const currentPlistImage = document.querySelectorAll(".mnsd_lookbook_plistwrap")[this.count - 1].querySelectorAll("img");
				const nextPlistImage = document.querySelectorAll(".mnsd_lookbook_plistwrap")[this.count].querySelectorAll("img");

				currentVisualImage.getAttribute("src") === "" && currentVisualImage.setAttribute("src", currentVisualImage.getAttribute("data-src"));
				nextVisualImage.getAttribute("src") === "" && nextVisualImage.setAttribute("src", nextVisualImage.getAttribute("data-src"));
				currentPlistImage.forEach((item, index) => item.getAttribute("src") === "" && item.setAttribute("src", item.getAttribute("data-src")));
				nextPlistImage.forEach((item, index) => item.getAttribute("src") === "" && item.setAttribute("src", item.getAttribute("data-src")));
			}
		},
		_initialSliceCount: function () {
			const slideCount = this.count < 10 ? "0" + this.count : this.count;
			const slideTotalCount = this.total < 10 ? "0" + this.total : this.total;
			this._welSlideCount.innerHTML = `${slideCount} / ${slideTotalCount}`;
		},
    _setInitialSlide: function () {
			this._welLooBookSlide.classList.add("slide" + this.count);
		},
		_handleAccessibility: function () {
			document.querySelectorAll(".mnsd_lookbook_plistwrap").forEach((item, index) => item.setAttribute("aria-hidden", "true"));
			document.querySelectorAll(".mnsd_lookbook_info").forEach((item, index) => item.setAttribute("aria-hidden", "true"));
			document.querySelectorAll(".mnsd_lookbook_visual").forEach((item, index) => item.setAttribute("aria-hidden", "true"));
			document.querySelectorAll(".mnsd_lookbook_plistwrap")[this.count - 1].setAttribute("aria-hidden", "false");
			document.querySelectorAll(".mnsd_lookbook_info")[this.count - 1].setAttribute("aria-hidden", "false");
			document.querySelectorAll(".mnsd_lookbook_visual")[this.count - 1].setAttribute("aria-hidden", "false");

			document.querySelectorAll(".mnsd_lookbook_plistwrap").forEach((item, index) => item.setAttribute("tabIndex", "-1"));
			document.querySelectorAll(".mnsd_lookbook_info").forEach((item, index) => item.setAttribute("tabIndex", "-1"));
			document.querySelectorAll(".mnsd_lookbook_visual").forEach((item, index) => item.setAttribute("tabIndex", "-1"));
			document.querySelectorAll(".mnsd_lookbook_plistwrap")[this.count - 1].setAttribute("tabIndex", "0");
			document.querySelectorAll(".mnsd_lookbook_info")[this.count - 1].setAttribute("tabIndex", "0");
			document.querySelectorAll(".mnsd_lookbook_visual")[this.count - 1].setAttribute("tabIndex", "0");
		},
		_attachEvent: function () {
			var self = this;
			this._welNextButton.addEventListener("click", this._handleNextEvent.bind(this));
			this._welPrevButton.addEventListener("click", this._handlePrevEvent.bind(this));
		},
		_handlePrevEvent: function () {
			if (this.count > 1 && this.flag) {
				this.flag = false;
				this._welLooBookSlide.classList.remove("slide" + this.count);
				this._welLooBookSlide.classList.add("slide" + (this.count - 1));
				this.count -= 1;
				this._initialSliceCount();
			}
			this._handleController();
			this._handleAccessibility();
		},
		_handleNextEvent: function () {
			if (this.total > this.count && this.flag) {
				this.flag = false;
				this.count += 1;
				this._initialSliceCount();
			}
			this._welLooBookSlide.classList.remove("slide" + (this.count - 1));
			this._welLooBookSlide.classList.add("slide" + this.count);
			this._handleController();
			this._handleAccessibility();
			this._setLazyLoadImage();
		},
		_handleController: function () {
			if (this.count <= 1) {
				this._welPrevButton.classList.add("hide");
			} else {
				this._welPrevButton.classList.remove("hide");
			}
			if (this.count >= this.total) {
				this._welNextButton.classList.add("hide");
			} else {
				this._welNextButton.classList.remove("hide");
			}
			this.flag = true;
		},
	},
	{}
);
mnsd.View.horizontalDrag = function () {
	this.init();
};
mnsd.View.horizontalDrag.prototype = {
	init: function () {
		this._assignElements();
		this._attachEventHandlers();
		this._initVar();
	},
	_initVar: function () {
    this._dragged = 0;
    this._isDown = false;
    this._startX;
    this._scrollLeft;
	},
	_assignElements: function () {
		this._welDragWrap = document.querySelector(`.cmhorizontal_dragitem`);
		this._welDrag = this._welDragWrap.querySelector(`.cmhorizontal_drag`);
		this._welProgressbBar = this._welDragWrap.querySelector(`.cmhorizontal_progressbar`);
		this._welProgressbPer = this._welProgressbBar.querySelector(`.cmhorizontal_progressbar_per`);
	},
	_attachEventHandlers: function () {
    this._welDrag.addEventListener('mousedown', (event) => {this._mousedown(event)});
    this._welDrag.addEventListener('mouseleave', () => {this._mouseleave()});
    this._welDrag.addEventListener('mouseup', () => {this._mouseup()});
    this._welDrag.addEventListener('mousemove', (event) => {this._mousemove(event)});
    this._welDrag.addEventListener(`scroll`,	(event) => {this._isScroll(event)})
	},
  _isScroll: function (event) {
    const progressValue = parseInt(this._progressbar(this._welDrag.scrollLeft, this._welDrag.scrollWidth - this._welDrag.offsetWidth));

    this._welProgressbPer.style.width = `${progressValue}%`
  },
  _progressbar: function (curr, max) {
    return (curr/max) * 100
  },
  _mousedown: function(event) {
    this._isDown = true;
    event.preventDefault();
    this._welDrag.classList.add('active');
    this._startX = event.pageX - this._welDrag.offsetLeft;
    this._scrollLeft = this._welDrag.scrollLeft;
  },
  _mouseleave: function(){
    this._isDown = false;
    this._welDrag.classList.remove('active');
  },
  _mouseup: function() {
    this._isDown = false;
    this._welDrag.classList.remove('active');
  },
  _mousemove: function(event) {
    if(!this._isDown) return;
    event.preventDefault();
    const x = event.pageX - this._welDrag.offsetLeft;
    const walk = (x - this._startX) * 3; //scroll-fast
    this._welDrag.scrollLeft = this._scrollLeft - walk;
  }
};
document.addEventListener(`DOMContentLoaded`, () => {
  var oMnsdNavigation = new mnsd.View.navigation();
  var oMnsdCategory = new mnsd.View.category();
})
